
import { useEffect, useState } from "react"
import styled from "styled-components"
import { getNakliyeSeasonIndex, getTopluNakliyeSeasonIndexExcel, updateNakliyeSeasonIndex } from "../../features/nakliyeIndex/nakliyeIndexSlice"
import { useDispatch, useSelector } from "react-redux"
import Btn from "../shared/button/Btn"
import InputSelect from "../shared/input/new/InputSelect"
import locationCityOptionsForIndex from "../../utils/locationData/locationCityOptionsForIndex"
import SmallSpinner from "../shared/spinners/SmallSpinner"
import { showModal } from "../../features/modal/modalSlice"
import { BiSolidSortAlt, BiSolidUpArrow, BiSolidDownArrow } from "react-icons/bi";

const Container = styled.div`
    display: flex;
    flex-direction: column;

    .top-container{ 
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 30px;

        .btn-container{
            display: flex;
            gap: 30px;

        }

    }

    .table{
        width: 100%;
        border-collapse: collapse;

        thead{
            width: 100%;
            background-color: var(--color-main);

            tr{

                th{
                    color: #fff;
                    padding: 10px 15px;
                    border-right: 1px solid #fff;
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-lg);

                    &:first-child{
                        text-align: start;
                        border-left: 1px solid var(--color-main);
                    }
                    
                    &:last-child{
                        border-right: 1px solid var(--color-main);
                    }

                    .title-text{
                        width: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        .sort-icon{
                            font-size: 1rem;
                            cursor: pointer;
                        }
                    }

                }
            }
        }

        tbody{

            tr{
                td{

                    border: 1px solid ${({theme}) => theme.mainTextColor};
                    text-align: center;
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-lg);

                    &:first-child{
                        /* background-color: ${({theme}) => theme.secondaryBgColor}; */
                        padding: 8px 15px;
                        text-align: start;
                    }

                    &:last-child{
                        width: 250px !important;
                    }

                    input{
                        width: 100%;
                        text-align: center;
                        padding: 8px 0;

                    }
                }
            }

        }
    }

    .bottom-container{
        margin-top: 30px;
        display: flex;
        justify-content: center;
    }
    
`


const initialTitles = [
    {
        id: 1,
        text: "İl/İlçe",
        sortState: 0
    },
    {
        id: 2,
        text: "Ocak",
        sortState: 0
    },
    {
        id: 3,
        text: "Şubat",
        sortState: 0
    },
    {
        id: 4,
        text: "Mart",
        sortState: 0
    },
    {
        id: 5,
        text: "Nisan",
        sortState: 0
    },
    {
        id: 6,
        text: "Mayıs",
        sortState: 0
    },
    {
        id: 7,
        text: "Haziran",
        sortState: 0
    },
    {
        id: 8,
        text: "Temmuz",
        sortState: 0
    },
    {
        id: 9,
        text: "Ağustos",
        sortState: 0
    },
    {
        id: 10,
        text: "Eylül",
        sortState: 0
    },
    {
        id: 11,
        text: "Ekim",
        sortState: 0
    },
    {
        id: 12,
        text: "Kasım",
        sortState: 0
    },
    {
        id: 13,
        text: "Aralık",
        sortState: 0
    },
    {
        id: 14,
        text: "Not & Açıklama"
    }
]

const NakliyeIsSezonIndex = () => {

    const dispatch = useDispatch()
    const {cityTownSeasonIndex, isLoadingGetTopluNakliyeSeasonIndexExcel} = useSelector(state => state.nakliyeIndex)

    const [updatedDataList, setUpdatedDataList] = useState([])

    //! bu filtreleme için
    const [townListOption, setTownListOption] = useState([])

    const [titles, setTitles] = useState(initialTitles)

    const [selectedCity, setSelectedCity] = useState({
        id:341,
        text: "İstanbul(Anadolu)"
    })

    useEffect(() => {
        setUpdatedDataList(cityTownSeasonIndex)
        setTownListOption(cityTownSeasonIndex)
    },[cityTownSeasonIndex])



    useEffect(() => {
        dispatch(getNakliyeSeasonIndex(selectedCity.id))
    },[selectedCity.id])


    const handleSortChange = ({id, sortState}) => {

        const titleList = titles.map((item) => {
            if(item.id === id){
                return {...item, sortState}
            }
            else{
                return { ...item, sortState: 0}
            }
        })

        if(id === 1){
            if(sortState === 0){
                setTownListOption([...townListOption].sort((a, b) => a.town.localeCompare(b.town, 'tr')))
            }
            else if(sortState === 1){
                setTownListOption([...townListOption].sort((a, b) => b.town.localeCompare(a.town, 'tr')))
            }
            else{
                setTownListOption([...townListOption].sort((a, b) => a.town.localeCompare(b.town, 'tr')))
            }
        }

        if(id === 2){
            if(sortState === 0){
                setTownListOption([...townListOption].sort((a, b) => a.town.localeCompare(b.town, 'tr')))
            }
            else if(sortState === 1){
                setTownListOption([...townListOption].sort((a, b) => a.ocak - b.ocak))
            }
            else{
                setTownListOption([...townListOption].sort((a, b) => b.ocak - a.ocak))
            }
        }

        if(id === 3){
            if(sortState === 0){
                setTownListOption([...townListOption].sort((a, b) => a.town.localeCompare(b.town, 'tr')))
            }
            else if(sortState === 1){
                setTownListOption([...townListOption].sort((a, b) => a.subat - b.subat))
            }
            else{
                setTownListOption([...townListOption].sort((a, b) => b.subat - a.subat))
            }
        }

        if(id === 4){
            if(sortState === 0){
                setTownListOption([...townListOption].sort((a, b) => a.town.localeCompare(b.town, 'tr')))
            }
            else if(sortState === 1){
                setTownListOption([...townListOption].sort((a, b) => a.mart - b.mart))
            }
            else{
                setTownListOption([...townListOption].sort((a, b) => b.mart - a.mart))
            }
        }

        if(id === 5){
            if(sortState === 0){
                setTownListOption([...townListOption].sort((a, b) => a.town.localeCompare(b.town, 'tr')))
            }
            else if(sortState === 1){
                setTownListOption([...townListOption].sort((a, b) => a.nisan - b.nisan))
            }
            else{
                setTownListOption([...townListOption].sort((a, b) => b.nisan - a.nisan))
            }
        }

        if(id === 6){
            if(sortState === 0){
                setTownListOption([...townListOption].sort((a, b) => a.town.localeCompare(b.town, 'tr')))
            }
            else if(sortState === 1){
                setTownListOption([...townListOption].sort((a, b) => a.mayis - b.mayis))
            }
            else{
                setTownListOption([...townListOption].sort((a, b) => b.mayis - a.mayis))
            }
        }

        if(id === 7){
            if(sortState === 0){
                setTownListOption([...townListOption].sort((a, b) => a.town.localeCompare(b.town, 'tr')))
            }
            else if(sortState === 1){
                setTownListOption([...townListOption].sort((a, b) => a.haziran - b.haziran))
            }
            else{
                setTownListOption([...townListOption].sort((a, b) => b.haziran - a.haziran))
            }
        }

        if(id === 8){
            if(sortState === 0){
                setTownListOption([...townListOption].sort((a, b) => a.town.localeCompare(b.town, 'tr')))
            }
            else if(sortState === 1){
                setTownListOption([...townListOption].sort((a, b) => a.temmuz - b.temmuz))
            }
            else{
                setTownListOption([...townListOption].sort((a, b) => b.temmuz - a.temmuz))
            }
        }
        
        if(id === 9){
            if(sortState === 0){
                setTownListOption([...townListOption].sort((a, b) => a.town.localeCompare(b.town, 'tr')))
            }
            else if(sortState === 1){
                setTownListOption([...townListOption].sort((a, b) => a.agustos - b.agustos))
            }
            else{
                setTownListOption([...townListOption].sort((a, b) => b.agustos - a.agustos))
            }
        }

        if(id === 10){
            if(sortState === 0){
                setTownListOption([...townListOption].sort((a, b) => a.town.localeCompare(b.town, 'tr')))
            }
            else if(sortState === 1){
                setTownListOption([...townListOption].sort((a, b) => a.eylul - b.eylul))
            }
            else{
                setTownListOption([...townListOption].sort((a, b) => b.eylul - a.eylul))
            }
        }

        if(id === 11){
            if(sortState === 0){
                setTownListOption([...townListOption].sort((a, b) => a.town.localeCompare(b.town, 'tr')))
            }
            else if(sortState === 1){
                setTownListOption([...townListOption].sort((a, b) => a.ekim - b.ekim))
            }
            else{
                setTownListOption([...townListOption].sort((a, b) => b.ekim - a.ekim))
            }
        }

        if(id === 12){
            if(sortState === 0){
                setTownListOption([...townListOption].sort((a, b) => a.town.localeCompare(b.town, 'tr')))
            }
            else if(sortState === 1){
                setTownListOption([...townListOption].sort((a, b) => a.kasim - b.kasim))
            }
            else{
                setTownListOption([...townListOption].sort((a, b) => b.kasim - a.kasim))
            }
        }

        if(id === 13){
            if(sortState === 0){
                setTownListOption([...townListOption].sort((a, b) => a.town.localeCompare(b.town, 'tr')))
            }
            else if(sortState === 1){
                setTownListOption([...townListOption].sort((a, b) => a.aralik - b.aralik))
            }
            else{
                setTownListOption([...townListOption].sort((a, b) => b.aralik - a.aralik))
            }
        }

        setTitles(titleList)
    }

    const handleChange = ({value, id, key}) => {

        const list = updatedDataList.map((item) => {
            if(item.id === id){
                return {...item, [key]: value === "" ? value : parseInt(value.replace(/[^0-9]/g, ''))}
            }
            else{
                return item
            }
        })

        setUpdatedDataList(list)
        setTownListOption(list)

    }

    const handleDescChange = ({value, id }) => {

        const list = updatedDataList.map((item) => {
            if(item.id === id){
                return {...item, description: value}
            }
            return item
        })
        setUpdatedDataList(list)
        setTownListOption(list)

    }

    const handleSubmit = () => {

        const filtered = updatedDataList.filter((item, i) => {
            const jsonString1 = JSON.stringify(item);
            const jsonString2 = JSON.stringify(cityTownSeasonIndex[i]);
            return jsonString1 !== jsonString2
        })    

        dispatch(updateNakliyeSeasonIndex(filtered))
    }

  return (
    <Container>

        <div className="top-container">
            <InputSelect data={selectedCity.text} setData={setSelectedCity} labelText={"İl Seçiniz"} inputWidth={"220px"} initialOptions={locationCityOptionsForIndex} name={"nakliyeSeasonIndexCity"}/>
            <div className="btn-container">
                <Btn borderColor="#E85446" color="#E85446" width={"200px"} handleClick={() => dispatch(showModal("nakliyeIndexCitySeasonAddExcel"))}>Excelden Toplu Kaydet</Btn>
                <Btn borderColor="#E85446" color="#E85446" width={"200px"} handleClick={() => dispatch(getTopluNakliyeSeasonIndexExcel())} isDisabled={isLoadingGetTopluNakliyeSeasonIndexExcel} cursor={isLoadingGetTopluNakliyeSeasonIndexExcel && "not-allowed"}>{isLoadingGetTopluNakliyeSeasonIndexExcel ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Excel Çıktı Al"}</Btn>
            </div>
        </div>
        <table className="table">
            <thead>
                <tr>
                    {
                        titles.map((item) => (
                            <th key={item.id}>
                            <div className={"title-text"}>
                                {item.text}
                                {
                                    item.sortState === 0 &&
                                    <BiSolidSortAlt onClick={() => handleSortChange({id: item.id, sortState: item.sortState === 2 ? 0 : item.sortState+1})} className="sort-icon"/>
                                }
                                {
                                    item.sortState === 1 &&
                                    <BiSolidUpArrow onClick={() => handleSortChange({id: item.id, sortState: item.sortState === 2 ? 0 : item.sortState+1})} className="sort-icon"/>
                                }
                                {
                                    item.sortState === 2 &&
                                    <BiSolidDownArrow onClick={() => handleSortChange({id: item.id, sortState: item.sortState === 2 ? 0 : item.sortState+1})} className="sort-icon"/>
                                }
                            </div>
                        </th>
                        ))
                    }
                </tr>
            </thead>
            <tbody>
                {
                    townListOption?.map((item) => (
                        <tr>
                            <td>{item.city}/{item.town}</td>
                            <td>
                                <input value={item.ocak} onChange={(e) => handleChange({value: e.target.value, id: item.id, key: "ocak"})}/>
                            </td>
                            <td>
                                <input value={item.subat} onChange={(e) => handleChange({value: e.target.value, id: item.id, key: "subat"})}/>
                            </td>
                            <td>
                                <input value={item.mart} onChange={(e) => handleChange({value: e.target.value, id: item.id, key: "mart"})}/>
                            </td>
                            <td>
                                <input value={item.nisan} onChange={(e) => handleChange({value: e.target.value, id: item.id, key: "nisan"})}/>
                            </td>
                            <td>
                                <input value={item.mayis} onChange={(e) => handleChange({value: e.target.value, id: item.id, key: "mayis"})}/>
                            </td>
                            <td>
                                <input value={item.haziran} onChange={(e) => handleChange({value: e.target.value, id: item.id, key: "haziran"})}/>
                            </td>
                            <td>
                                <input value={item.temmuz} onChange={(e) => handleChange({value: e.target.value, id: item.id, key: "temmuz"})}/>
                            </td>
                            <td>
                                <input value={item.agustos} onChange={(e) => handleChange({value: e.target.value, id: item.id, key: "agustos"})}/>
                            </td>
                            <td>
                                <input value={item.eylul} onChange={(e) => handleChange({value: e.target.value, id: item.id, key: "eylul"})}/>
                            </td>
                            <td>
                                <input value={item.ekim} onChange={(e) => handleChange({value: e.target.value, id: item.id, key: "ekim"})}/>
                            </td>
                            <td>
                                <input value={item.kasim} onChange={(e) => handleChange({value: e.target.value, id: item.id, key: "kasim"})}/>
                            </td>
                            <td>
                                <input value={item.aralik} onChange={(e) => handleChange({value: e.target.value, id: item.id, key: "aralik"})}/>
                            </td>
                            <td>
                                <input type="text" value={item.description} onChange={(e) => handleDescChange({value: e.target.value, id: item.id})} />
                            </td>
                        </tr>
                    ))
                }
             </tbody>
        </table>
        <div className="bottom-container">
            <Btn handleClick={handleSubmit} bgColor="#E85446" color="#fff" width={"260px"}>Güncelle</Btn>
        </div>
    </Container>
  )
}

export default NakliyeIsSezonIndex